const CONFIGURED_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const BACKEND_URL = process.env.NODE_ENV === "production" ? "" : CONFIGURED_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const request = async (path, token, options = {}) => {
  const response = await fetch(`${API}${path}`, {
    credentials: "include",
    headers: {
      ...(options.body ? { "Content-Type": "application/json" } : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
    ...options,
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    const error = new Error(body.detail || `Request failed: ${response.status}`);
    error.status = response.status;
    throw error;
  }

  return response.json();
};

export const getIntelligenceOverview = async (token, profileUserId) => request(`/intelligence/overview${profileUserId ? `?profile_user_id=${encodeURIComponent(profileUserId)}` : ""}`, token);
export const getIntelligenceHome = async (token, profileUserId) => request(`/intelligence/home${profileUserId ? `?profile_user_id=${encodeURIComponent(profileUserId)}` : ""}`, token);
export const getMorningBrief = async (token, profileUserId) => request(`/intelligence/morning-brief${profileUserId ? `?profile_user_id=${encodeURIComponent(profileUserId)}` : ""}`, token);
export const getNotifications = async (token) => request("/intelligence/notifications", token);
export const getDecisions = async (token) => request("/intelligence/decisions", token);
export const createCapture = async (payload, token) => request("/intelligence/capture", token, { method: "POST", body: JSON.stringify(payload) });
export const createBelief = async (payload, token) => request("/intelligence/beliefs", token, { method: "POST", body: JSON.stringify(payload) });
export const createDecision = async (payload, token) => request("/intelligence/decisions", token, { method: "POST", body: JSON.stringify(payload) });
export const updateAionFile = async (payload, token) => request("/intelligence/aion-file", token, { method: "PUT", body: JSON.stringify(payload) });
export const runIntelligenceSkill = async (skillName, token) => request(`/intelligence/skills/${skillName}/run`, token, { method: "POST" });
export const markNotificationRead = async (notificationId, token) => request(`/intelligence/notifications/${notificationId}/read`, token, { method: "POST" });
export const archiveNotification = async (notificationId, token) => request(`/intelligence/notifications/${notificationId}/archive`, token, { method: "POST" });

export const getProjectIntelligenceCatalog = async (token) => request("/intelligence/project-intelligence/catalog", token);
export const getProjectIntelligenceOverview = async (token) => request("/intelligence/project-intelligence/overview", token);
export const getProjectIntelligenceDetail = async (projectKey, token) => request(`/intelligence/project-intelligence/projects/${encodeURIComponent(projectKey)}`, token);
export const ingestProjectIntelligenceSnapshot = async (payload, token) => request("/intelligence/project-intelligence/snapshots", token, { method: "POST", body: JSON.stringify(payload) });

export const getProjectIntelligenceConnectors = async (token) => request("/intelligence/project-intelligence/connectors", token);
export const syncProjectIntelligenceConnectors = async (token) => request("/intelligence/project-intelligence/connectors/sync", token, { method: "POST" });
export const syncProjectIntelligenceConnector = async (projectKey, token) => request(`/intelligence/project-intelligence/connectors/${encodeURIComponent(projectKey)}/sync`, token, { method: "POST" });
